<template lang="pug">
  //- 日日抽弹窗 未中奖弹窗
  .winning-dialog-container(
    v-if="show && dialogData.prizes && dialogData.prizes.length"
    @touchmove.prevent
    )
    .shadow(@click="close")
    .dialog-content
      .box
        .title 会员日日抽 {{ dialogData.propertyCreateTime || '' }}
        .box-content
          .winning-one(v-if="dialogData.prizes && dialogData.prizes.length === 1")
            img.logo(:src="dialogData.prizes[0].icon || ''")
            .text(v-if="dialogData.prizes[0].prizeType!==26") {{ dialogData.prizes[0].prizeName || '' }}
            .award(v-else)
              .span 奖励金
              .span.award-num(v-if="dialogData.prizes[0].worth") +{{dialogData.prizes[0].worth}}
          .winning-two(v-else-if="dialogData.prizes && dialogData.prizes.length === 2")
            .item(v-for="(item, index) in dialogData.prizes" :key="index")
              img.logo(:src="item.icon || ''")
              .text(v-if="item.prizeType!==26") {{ item.prizeName || '' }}
              .award(v-else)
                .span 奖励金
                .span.award-num(v-if="item.worth") +{{item.worth}}
          .winning-multi(
            v-else-if="dialogData.prizes && dialogData.prizes.length > 2"
            @touchmove.stop)
            .item(v-for="(item, index) in dialogData.prizes" :key="index")
              img.logo(:src="item.icon || ''")
              .text(v-if="item.prizeType!==26") {{ item.prizeName || '' }}
              .award(v-else)
                .span 奖励金
                .span.award-num(v-if="item.worth") +{{item.worth}}
      .btn(@click="jumpUrl") 去查看
      .close(@click="close")
  </template>
<script>
import config from '@/const/config';
import { Navigator } from '@hb/h5-navigator';
import { ParamsUtil } from '@/utils/params';
import { SignedCoinImg } from '@/assets/imgAssets';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: () => ({}),
    },
    currentOrderOptType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      SignedCoinImg,
    };
  },
  watch: {
  },
  created() { },
  mounted() { },
  destroyed() {
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    },
    /** 定位到「我活的的」tab */
    jumpUrl() {
      const recordUrl = `https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env === 'dev' ? 'fat' : config.env}/`}latest/index.html#/vip/v3/lotteryRecord`;
      //  MOCK
      // const recordUrl = 'http://172.17.190.40:1024/#/vip/v3/lotteryRecord?tab=1';
      const url = ParamsUtil.addParams(recordUrl, {
        campaignCode: (this.dialogData && this.dialogData.campaignCode) || '',
        tab: 1,
        batchNo: this.dialogData.batchNo || '',
        currentOrderOptType: this.currentOrderOptType !== undefined ? this.currentOrderOptType : null,
      });
      Navigator.go(url);
    },
  },
};
</script>

<style lang="less" scoped>
.winning-dialog-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;

  .lottie {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    pointer-events: none;
  }

  .shadow {
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.7;
    position: absolute;
    left: 0;
    top: 0;
  }

  .dialog-content {
    position: relative;
    width: 3.03rem;
    height: 3.91rem;
    z-index: 1;

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 3.03rem;
      height: 3.18rem;
      background-image: url('https://m.hellobike.com/resource/gallery/59/jc0lrR4HyJ.png?x-oss-process=image/quality,q_80');
      background-size: 100%;
      background-repeat: no-repeat;
      padding-top: 0.87rem;

      .box-content {
        margin-top: 0.05rem;
        width: 2.15rem;
        height: 1.98rem;

        .winning-one {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          padding-top: 0.24rem;
        }

        .winning-two {
          display: flex;
          justify-content: space-between;
          padding: 0.4rem 0.14rem 0;
          width: 100%;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;

            .logo {
              width: 0.8rem;
              height: 0.8rem;
            }

            .text {
              max-width: 0.8rem;
              font-weight: 500;
              font-size: 0.12rem;
              color: #242729;
              margin-top: 0.08rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .winning-multi {
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          padding: 0.4rem 0 0 0.14rem;
          overflow-x: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;

          &::-webkit-scrollbar {
            display: none;
          }

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-right: 0.14rem;

            .logo {
              width: 0.8rem;
              height: 0.8rem;
              object-fit: contain;
            }

            .text {
              max-width: 0.8rem;
              font-weight: 500;
              font-size: 0.12rem;
              color: #242729;
              margin-top: 0.08rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .award {
              margin-top: 0.08rem;
            }
          }
        }

        .logo {
          width: 1rem;
          height: 1rem;
        }

        .text {
          margin-top: 0.12rem;
        }

        .coin-img {
          width: 0.82rem;
          height: 0.56rem;
          margin-top: 0.4rem;
        }

        .award {
          color: rgba(36, 39, 41, 1);
          font-weight: 500;
          font-family: PingFang SC, sans-serif;
          font-size: 0.12rem;
          margin-top: 0.26rem;
          display: flex;
          align-items: center;
        }

        .award-num {
          color: rgba(255, 87, 41, 1);
          margin-left: 0.02rem;
        }
      }

      .title {
        font-weight: 600;
        font-size: 0.14rem;
        text-align: center;
        color: #7d3b2a;
      }
    }

    .btn {
      width: 1.11rem;
      height: 0.4rem;
      margin: 0.22rem auto;
      background-color: #fb990f;
      border-radius: 0.32rem;
      font-weight: 600;
      font-size: 0.14rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
    }

    .close {
      position: absolute;
      left: calc(50% - 0.15rem);
      bottom: calc(-0.35rem - 0.15rem);
      width: 0.3rem;
      height: 0.3rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/Hgiou4vp_close.png);
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
}
</style>
